// NEW_FILE_JUSTIFIED: Shared message utility functions extracted from useTelegramMessages and useGmailMessages to eliminate duplication. No existing utility file covers avatar coloring, initials generation, time formatting, or email sender parsing for the messages domain.

/** Generate up-to-2-letter initials from a display name */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? '')
    .join('');
}

/** Deterministic avatar background color derived from a contact ID string */
export const AVATAR_COLORS = [
  '#0D9488',
  '#6366F1',
  '#E07B54',
  '#B8EF70',
  '#F59E0B',
  '#EC4899',
  '#8B5CF6',
  '#06B6D4',
] as const;

export function getAvatarColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length] ?? AVATAR_COLORS[0];
}

/**
 * Format a Unix-ms timestamp to a human-readable short string:
 * - Same day  -> "2:30 PM"
 * - Within 7 days -> "Mon"
 * - Older -> "Jan 5"
 */
export function formatTime(timestampMs: number): string {
  const date = new Date(timestampMs);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }
  if (diffDays < 7) {
    return date.toLocaleDateString([], { weekday: 'short' });
  }
  return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

/** Extract display name from a "Name <email>" string */
export function extractFromName(from: string): string {
  const match = from.match(/^([^<]+)</);
  if (match) return match[1]?.trim() ?? from;
  return from.split('@')[0] ?? from;
}
